import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';
import MyLink from '../../modules/MyLink';

import '../../css/product.scss';

class Index extends Component {

  componentDidMount() {
    // eslint-disable-next-line no-restricted-globals
    if (this.$ref && location.href.includes('#products')) {
      this.$ref.scrollIntoView({
        // optional params
        behavior: 'smooth',
        block: 'start',
        inline: 'center',
      });
    }
  }


  render() {
    const {t, i18n} = this.props;
    const products = ["dedicated", "cloud", "vps", "ddos", "colocation", "cdn", "storage", "vpn", "apps"];
    return (
      <div className={'center'} ref={ref => {
        this.$ref = ref;
      }}>
        <div className={'max-width product-pre-container'} style={{paddingBottom: 0}}>
          <h2>{t('title')}</h2>
          <div className={'h-text2-last'}>{t('text')}</div>
          <div className={'product-container'}>
            {products.map(product => (
                <div className={'item'} key={product}>
                  <div>
                    <div className={'icon ' + product}/>
                    <div className={'title'}>{t(product + '.title')}</div>
                    <div className={'text'}>{t(product + '.text')}</div>
                  </div>
                  <MyLink to={'/' + i18n.language + '/' + product} text={t('learn-more')}/>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(translate('product')(Index));
